import { Component, OnInit } from '@angular/core';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import * as moment from 'moment';
import { WaitingDialogComponent } from 'src/app/shared/waiting-dialog/waiting-dialog.component';
import { AbmPopupComponent } from '../abm-popup/abm-popup.component';
import { RbmPopupComponent } from '../rbm-popup/rbm-popup.component';
import { ReportsService } from '../reports.service';
import { RsPopupComponent } from '../rs-popup/rs-popup.component';

@Component({
  selector: 'app-dashboard-reports',
  templateUrl: './dashboard-reports.component.html',
  styleUrls: ['./dashboard-reports.component.scss']
})
export class DashboardReportsComponent implements OnInit {

  constructor(public reportsService: ReportsService, private modalService: MDBModalService) { 
    this.fromDateValue.setDate(this.fromDateValue.getDate() - 30);
   this.fromDateValue =  moment(this.fromDateValue).format('YYYY-MM-DD');
   
  }
  selectedRegion: string = 'WEST';
  fromDate: any = '01-01-2022';
  toDate: any = '31-01-2022';
  toDateValue = moment(new Date()).format('YYYY-MM-DD');
  fromDateValue: any = new Date(); 
  MaxToDate :any  = moment(new Date()).format('YYYY-MM-DD');
  today = moment(new Date()).format('YYYY-MM-DD'); 
  tableData :any[] = [];
  abmTable :any[] = [];
  rsmTable :any[] = [];
  regionList: any[]= [];
  ngOnInit() {
    this.getRegion();
  }

  onDateChange(event) {
    console.log("from", this.fromDateValue);
    console.log("to", this.toDateValue);
    let date = new Date(this.fromDateValue);
    date.setDate(date.getDate() + 30);
    this.MaxToDate =  moment(date).format('YYYY-MM-DD');
    this.toDateValue = moment(date).format('YYYY-MM-DD');
    // this.getReports();
  }

  getRegion() {
    this.reportsService.getRegion().then((data: any) => {
       this.regionList = data;
       this.selectedRegion = data[0].Region;
       this.getDashboardReport();
       }, errorCode => console.log(errorCode));
}
waitingModalRef: MDBModalRef;
  getDashboardReport() {
    this.waitingModalRef = this.modalService.show(WaitingDialogComponent, {
      data: {
        message: 'Fetching Product Details'
      }
    })
      this.reportsService.getDashboardReport(this.fromDateValue, this.toDateValue, this.selectedRegion).then((data: any) => {
        if(data) {
        this.tableData = data;
         setTimeout(x => {
          this.waitingModalRef.hide();
        }, 300);
         }else {
          setTimeout(x => {
            this.waitingModalRef.hide();
          }, 300);
         }  }, (error) => {
          setTimeout(x => {
            this.waitingModalRef.hide();
          }, 500)
          console.log(error);
        
        });
      }

  schemeModalRef: MDBModalRef;
  openRbmPopup(code) {
    console.log("code");
    console.log(code);
    let data = {FromDate : this.fromDateValue, ToDate : this.toDateValue, Region: this.selectedRegion, code: code}
    this.schemeModalRef = this.modalService.show(RbmPopupComponent, {
      data: {
        message: '',
        data: data
      }, class:  'modal-md', backdrop: 'static'
    });
    this.schemeModalRef.content.action.subscribe((result: any) => {
      if (result == 'OK') {
            this.schemeModalRef.hide();
      }
    });
  }


  openAbmPopup(code) {
    console.log("code");
    console.log(code);
    let data = {FromDate : this.fromDateValue, ToDate : this.toDateValue, Region: this.selectedRegion,code: code}
    this.schemeModalRef = this.modalService.show(AbmPopupComponent, {
      data: {
        message: '',
        data: data
      }, class:  'modal-md', backdrop: 'static'
    });
    this.schemeModalRef.content.action.subscribe((result: any) => {
      if (result == 'OK') {
            this.schemeModalRef.hide();
      }
    });
  }


  openRsPopup(code) {
    console.log("code");
    console.log(code);
    let data = {FromDate : this.fromDateValue, ToDate : this.toDateValue, Region: this.selectedRegion, code: code}
    this.schemeModalRef = this.modalService.show(RsPopupComponent, {
      data: {
        message: '',
        data: data
      }, class:  'modal-lg', backdrop: 'static'
    });
    this.schemeModalRef.content.action.subscribe((result: any) => {
      if (result == 'OK') {
            this.schemeModalRef.hide();
      }
    });
  }

  
}
